// - PNG Images
import homeBanner1 from "../assets/images/png/homeBanner1.png";
import homeBanner2 from "../assets/images/png/homeBanner2.png";
import homeBanner3 from "../assets/images/png/homeBanner3.png";
import mobileHomeBanner1 from "../assets/images/png/mobileHomeBanner1.png";
import mobileHomeBanner2 from "../assets/images/png/mobileHomeBanner2.png";
import mobileHomeBanner3 from "../assets/images/png/mobileHomeBanner3.png";
import journey from "../assets/images/png/journey.png";
import studentGirl from "../assets/images/png/studentGirl.png";
import pageTitleBanner from "../assets/images/png/pageTitleBanner.png";
import aboutUsCardOneVector from "../assets/images/png/aboutUsCardOneVector.png";
import aboutUsCardTwoVector from "../assets/images/png/aboutUsCardTwoVector.png";
import aboutUsCardThreeVector from "../assets/images/png/aboutUsCardThreeVector.png";
import aboutUsCardFourVector from "../assets/images/png/aboutUsCardFourVector.png";
import contactUsBanner from "../assets/images/png/contactUsBanner.png";
import serviceOne from "../assets/images/png/serviceOne.png";
import serviceTwo from "../assets/images/png/serviceTwo.png";
import serviceThree from "../assets/images/png/serviceThree.png";
import serviceFour from "../assets/images/png/serviceFour.png";
import serviceFive from "../assets/images/png/serviceFive.png";
import downloadAppQr from "../assets/images/png/downloadAppQr.png";
import downloadAppPhone from "../assets/images/png/downloadAppPhone.png";
import bharatSatMobile from "../assets/images/png/bharatSatMobile.png";
import bharatSatDesktop from "../assets/images/png/bharatSatDesktop.png";
import CoordinatorCardPerson from "../assets/images/png/CoordinatorCardPerson.png";
import testimonialImage from "../assets/images/png/testimonialImage.png";
import loginPopupIllustration from "../assets/images/png/loginPopupIllustration.png";
import HomeBannerPopup from "../assets/images/png/HomeBannerPopup.png";
import HomeBannerImage from "../assets/images/png/HomeBannerImage.png";
import rewardCoordinator from "../assets/images/png/rewardCoordinator.png";
import compilanceCoordinator from "../assets/images/png/compilanceCoordinator.png";
import joinAsCoordinatorFormBackground from "../assets/images/png/joinAsCoordinatorFormBackground.png";
import joinAsCoordinatorAnnouncement from "../assets/images/png/joinAsCoordinatorAnnouncement.png";
import registerCoordinator from "../assets/images/png/registerCoordinator.png";
import rewardsDistrictLevel from "../assets/images/png/rewardsDistrictLevel.png";
import rewardsTrophy from "../assets/images/png/rewardsTrophy.png";
import bharatSATStudentRegistration from '../assets/images/png/bharatSATStudentRegistration.png';
import studentregistrationmobile from '../assets/images/png/studentregistrationmobile.png';
import bloguser from '../assets/images/png/bloguser.png';
import blogcalender from '../assets/images/png/blogcalender.png';
import blogdetailimage from '../assets/images/png/blogdetailimage.png';
import resetpopup from '../assets/images/png/resetpopup.png';
import dashboardLogo from '../assets/images/png/dashboardLogo.png';
import scienceone from '../assets/images/png/scienceone.png';
import sciencetwo from '../assets/images/png/sciencetwo.png';
import english from '../assets/images/png/english.png';
import history from '../assets/images/png/history.png';
import geography from '../assets/images/png/geography.png';
import no_record from '../assets/images/png/no_record.png';
import free_icon from '../assets/images/png/free_icon.png';
import Group from '../assets/images/png/Group.png';
import payment_fail from '../assets/images/png/payment_fail.png';
import payment_success from '../assets/images/png/payment_success.png';
import time_taken from '../assets/images/png/time_taken.png';
import incorrect from '../assets/images/png/incorrect.png';
import fileplus from '../assets/images/png/fileplus.png';
import correct from '../assets/images/png/correct.png';
import attempted from '../assets/images/png/attempted.png';
import light_bulb from '../assets/images/png/light_bulb.png'
import testone from '../assets/images/png/testone.png'
import redcross from '../assets/images/png/redcross.png'
import paidsyllabuspng from '../assets/images/png/paidsylaabuspng.png'
import timeicon from '../assets/images/png/timeicon.png'
import examsubmitpic from '../assets/images/png/examsubmitpic.png'
import bharatsatexamlogin from '../assets/images/png/bharatsatexamlogin.png'
import learnachievebharatsatlogo from '../assets/images/png/learnachievebharatsatlogo.png'
import ticketdesign from '../assets/images/png/ticketdesign.png'
import earlyexamimage from '../assets/images/png/earlyexamimage.png'
import multiple_device from '../assets/images/png/multiple_device.png'
import chrome_windows from '../assets/images/png/chrome_windows.png'
import complete_Exam from '../assets/images/png/complete_Exam.png'




// - SVG Images
import logo from "../assets/images/svg/logo.svg";
import logoWhite from "../assets/images/svg/logoWhite.svg";
import back_arrow_login from "../assets/images/svg/back_arrow_login.svg";
import buttonEndPattern from "../assets/images/svg/buttonEndPattern.svg";
import navBarMenu from "../assets/images/svg/navBarMenu.svg";
import journeyCardOneIcon from "../assets/images/svg/journeyCardOneIcon.svg";
import journeyCardTwoIcon from "../assets/images/svg/journeyCardTwoIcon.svg";
import journeyCardThreeIcon from "../assets/images/svg/journeyCardThreeIcon.svg";
import uspOne from "../assets/images/svg/uspOne.svg";
import uspTwo from "../assets/images/svg/uspTwo.svg";
import uspThree from "../assets/images/svg/uspThree.svg";
import uspFour from "../assets/images/svg/uspFour.svg";
import uspCardHoverTag from "../assets/images/svg/uspCardHoverTag.svg";
import studentGirlVectorGraphics from "../assets/images/svg/studentGirlVectorGraphics.svg";
import phone from "../assets/images/svg/phone.svg";
import email from "../assets/images/svg/email.svg";
import footerOverlay from "../assets/images/svg/footerOverlay.svg";
import breadcrumpArrow from "../assets/images/svg/breadcrumpArrow.svg";
import rightArrow from "../assets/images/svg/rightArrow.svg";
import time from "../assets/images/svg/time.svg";
import androidIcon from "../assets/images/svg/androidIcon.svg";
import iOSIcon from "../assets/images/svg/iOSIcon.svg";
import tickMark from "../assets/images/svg/tickMark.svg";
import otpVerification from "../assets/images/svg/otpVerification.svg";
import personalDetails from "../assets/images/svg/personalDetails.svg";
import facebook from "../assets/images/svg/facebook.svg";
import instagram from "../assets/images/svg/instagram.svg";
import linkedin from "../assets/images/svg/linkedin.svg";
import youtube from "../assets/images/svg/youtube.svg";
import twitter from "../assets/images/svg/twitter.svg";
import close from "../assets/images/svg/close.svg";
import mockTestUnderline from "../assets/images/svg/mockTestUnderline.svg";
import homeBannerModalbullet from "../assets/images/svg/homeBannerModalbullet.svg";
import rewardRankTrophy from "../assets/images/svg/rewardRankTrophy.svg";
import rewardRankMedal from "../assets/images/svg/rewardRankMedal.svg";
import rewardAchievementCardBackground from "../assets/images/svg/rewardAchievementCardBackground.svg";
import bharatSATStudentBackIllustration from "../assets/images/svg/bharatSATStudentBackIllustration.svg";
import checkmarkright from '../assets/images/svg/checkmarkright.svg';
import datepickerlogo from '../assets/images/svg/datepickerlogo.svg';
import location from '../assets/images/svg/location.svg';
import blogrightarrow from '../assets/images/svg/blogrightarrow.svg';
import whatsapp from '../assets/images/svg/whatsapp.svg';
import lock from '../assets/images/svg/lock.svg';
import password_hide from "../assets/images/svg/password_hide.svg";
import password_show from "../assets/images/svg/password_show.svg";
import menu_icon from "../assets/images/svg/menu_icon.svg";
import user_profile from "../assets/images/svg/user_profile.svg";
import profile_editng from "../assets/images/svg/profile_editng.svg";
import addtocart from "../assets/images/svg/addtocart.svg";
import student_notification from "../assets/images/svg/student_notification.svg";
import powerbutton from "../assets/images/svg/powerbutton.svg";
import module_icon from "../assets/images/svg/module_icon.svg";
import download_invoice from "../assets/images/svg/download_invoice.svg";
import deleteIcon from "../assets/images/svg/deleteIcon.svg";
import cross from "../assets/images/svg/cross.svg";
import packages from "../assets/images/svg/packages.svg";
import studymaterials from "../assets/images/svg/studymaterials.svg";
import mocktest from "../assets/images/svg/mocktest.svg";
import orderhistory from "../assets/images/svg/orderhistory.svg";
import changepassword from "../assets/images/svg/changepassword.svg";
import profile from "../assets/images/svg/profile.svg";
import coordinatornotification from "../assets/images/svg/coordinatornotification.svg";
import coordinatorpowerbtn from "../assets/images/svg/coordinatorpowerbtn.svg";
import camera from "../assets/images/svg/camera.svg";
import amount from "../assets/images/svg/amount.svg";
import received from "../assets/images/svg/received.svg";
import balance from "../assets/images/svg/balance.svg";
import withdraw from "../assets/images/svg/withdraw.svg";
import coarow from "../assets/images/svg/coarow.svg";
import crownimg from "../assets/images/svg/crownimg.svg";
import bharatset from "../assets/images/svg/bharatset.svg";
import early from "../assets/images/svg/early.svg"





// - PNG Images Export
export const PngImages = {
  homeBanner1: homeBanner1,
  homeBanner2: homeBanner2,
  homeBanner3: homeBanner3,
  mobileHomeBanner1: mobileHomeBanner1,
  mobileHomeBanner2: mobileHomeBanner2,
  mobileHomeBanner3: mobileHomeBanner3,
  journey: journey,
  studentGirl: studentGirl,
  pageTitleBanner: pageTitleBanner,
  aboutUsCardOneVector: aboutUsCardOneVector,
  aboutUsCardTwoVector: aboutUsCardTwoVector,
  aboutUsCardThreeVector: aboutUsCardThreeVector,
  aboutUsCardFourVector: aboutUsCardFourVector,
  contactUsBanner: contactUsBanner,
  serviceOne: serviceOne,
  serviceTwo: serviceTwo,
  serviceThree: serviceThree,
  serviceFour: serviceFour,
  serviceFive: serviceFive,
  downloadAppQr: downloadAppQr,
  downloadAppPhone: downloadAppPhone,
  bharatSatMobile: bharatSatMobile,
  bharatSatDesktop: bharatSatDesktop,
  CoordinatorCardPerson: CoordinatorCardPerson,
  testimonialImage: testimonialImage,
  loginPopupIllustration: loginPopupIllustration,
  HomeBannerPopup: HomeBannerPopup,
  HomeBannerImage: HomeBannerImage,
  rewardCoordinator: rewardCoordinator,
  compilanceCoordinator: compilanceCoordinator,
  joinAsCoordinatorFormBackground: joinAsCoordinatorFormBackground,
  joinAsCoordinatorAnnouncement: joinAsCoordinatorAnnouncement,
  registerCoordinator: registerCoordinator,
  rewardsDistrictLevel: rewardsDistrictLevel,
  rewardsTrophy: rewardsTrophy,
  bharatSATStudentRegistration: bharatSATStudentRegistration,
  studentregistrationmobile: studentregistrationmobile,
  bloguser: bloguser,
  blogcalender: blogcalender,
  blogdetailimage: blogdetailimage,
  resetpopup: resetpopup,
  dashboardLogo: dashboardLogo,
  scienceone: scienceone,
  sciencetwo: sciencetwo,
  english: english,
  history: history,
  geography: geography,
  no_record: no_record,
  free_icon: free_icon,
  Group: Group,
  payment_success: payment_success,
  payment_fail: payment_fail,
  time_taken: time_taken,
  incorrect: incorrect,
  fileplus: fileplus,
  correct: correct,
  attempted: attempted,
  light_bulb: light_bulb,
  testone: testone,
  redcross: redcross,
  paidsyllabuspng: paidsyllabuspng,
  timeicon: timeicon,
  examsubmitpic: examsubmitpic,
  bharatsatexamlogin: bharatsatexamlogin,
  learnachievebharatsatlogo:learnachievebharatsatlogo,
  ticketdesign:ticketdesign,
  earlyexamimage:earlyexamimage,
  multiple_device:multiple_device,
  chrome_windows:chrome_windows,
  complete_Exam:complete_Exam,


};

// - SVG Images Export
export const SvgImages = {
  logo: logo,
  logoWhite: logoWhite,
  back_arrow_login: back_arrow_login,
  buttonEndPattern: buttonEndPattern,
  navBarMenu: navBarMenu,
  journeyCardOneIcon: journeyCardOneIcon,
  journeyCardTwoIcon: journeyCardTwoIcon,
  journeyCardThreeIcon: journeyCardThreeIcon,
  uspOne: uspOne,
  uspTwo: uspTwo,
  uspThree: uspThree,
  uspFour: uspFour,
  uspCardHoverTag: uspCardHoverTag,
  studentGirlVectorGraphics: studentGirlVectorGraphics,
  phone: phone,
  email: email,
  footerOverlay: footerOverlay,
  breadcrumpArrow: breadcrumpArrow,
  rightArrow: rightArrow,
  time: time,
  androidIcon: androidIcon,
  iOSIcon: iOSIcon,
  tickMark: tickMark,
  otpVerification: otpVerification,
  personalDetails: personalDetails,
  facebook: facebook,
  instagram: instagram,
  linkedin: linkedin,
  youtube: youtube,
  twitter: twitter,
  close: close,
  mockTestUnderline: mockTestUnderline,
  homeBannerModalbullet: homeBannerModalbullet,
  rewardRankTrophy: rewardRankTrophy,
  rewardRankMedal: rewardRankMedal,
  rewardAchievementCardBackground: rewardAchievementCardBackground,
  bharatSATStudentBackIllustration: bharatSATStudentBackIllustration,
  checkmarkright: checkmarkright,
  datepickerlogo: datepickerlogo,
  location: location,
  blogrightarrow: blogrightarrow,
  whatsapp: whatsapp,
  lock: lock,
  password_hide: password_hide,
  password_show: password_show,
  menu_icon: menu_icon,
  user_profile: user_profile,
  profile_editng: profile_editng,
  addtocart: addtocart,
  student_notification: student_notification,
  powerbutton: powerbutton,
  module_icon: module_icon,
  download_invoice: download_invoice,
  deleteIcon: deleteIcon,
  download_invoice: download_invoice,
  deleteIcon: deleteIcon,
  cross: cross,
  packages: packages,
  studymaterials: studymaterials,
  mocktest: mocktest,
  orderhistory: orderhistory,
  changepassword: changepassword,
  profile: profile,
  coordinatornotification: coordinatornotification,
  coordinatorpowerbtn: coordinatorpowerbtn,
  camera: camera,
  amount: amount,
  received: received,
  balance: balance,
  withdraw: withdraw,
  coarow: coarow,
  packages: packages,
  studymaterials: studymaterials,
  crownimg: crownimg,
  bharatset: bharatset,
  early:early,

};
